import { render } from "./AddCard.vue?vue&type=template&id=920da06c&scoped=true"
import script from "./AddCard.vue?vue&type=script&lang=js"
export * from "./AddCard.vue?vue&type=script&lang=js"

import "./AddCard.vue?vue&type=style&index=0&id=920da06c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-920da06c"]])

export default __exports__